<template>
  <modal :closeable="false">
    <div class="row">
      <div class="col-4 text-left">
        <outline-button :border="false" @click.prevent="abort" back>
          {{$t('buttons.back')}}
        </outline-button>
      </div>
      <div class="col-8 text-right">
        <router-link :to="{path: '/signup', query: $route.query}" class="button-link">
          {{ $t('buttons.not_a_member')}}
        </router-link>
      </div>
    </div>
    <h3 class="title mt-3">{{ $t('buttons.reset_password')}}</h3>
    <form class="form needs-validation mt-3" @submit="recover">
      <input-group :label="$t('labels.password')">
        <input
          type="password"
          v-model="password"
          required
          @blur="check('password')"
          name="password"
        />
        <small class="error" v-if="errors.password">{{errors.password}}</small>
      </input-group>
      <input-group :label="$t('labels.password2')">
        <input
            type="password"
            v-model="password2"
            name="password2"
            required
            @blur="check('password2')"
        />
        <small class="error" v-if="errors.password2">{{errors.password2}}</small>
      </input-group>
      <p class="mt-3 text-right">
        <primary-button :full-width="false" :disabled="!valid" type="submit" cta>{{ $t('buttons.save')}}</primary-button>
      </p>
    </form>
  </modal>
</template>

<script>
import InputGroup from '@/components/input/InputGroup.vue'
import PrimaryButton from '@/components/buttons/PrimaryButton.vue'
import OutlineButton from '@/components/buttons/OutlineButton.vue'
import Modal from '@/components/modal/ModalRegular.vue'
import {SET_IS_ERROR} from '@/store/mutationTypes'
import {SET_INVITE_CODES} from "../../store/mutationTypes";
import {parseInviteCodesFromUri} from "../../utils";

export default {
  data () {
    return {
      errors: {
        password: false,
        password2: false
      },
      token: '',
      password: '',
      password2: '',
    }
  },

  computed: {
    valid () {
      return this.password.length >= 5 && this.password == this.password2
    }
  },

  methods: {
    abort() {
      this.$router.push({path: '/signup/login', query: this.$route.query})
    },
    check(field) {
      if (field == 'password') {
        this.errors.password = this.password.length >= 5 ? false : this.$t('errors.min_length', {min: 5})
        this.check('password2')
        return
      }
      if (field == 'password2') {
        this.errors.password2 = this.password2.length >= 5 ?
            (this.password2 == this.password ? false : this.$t('errors.password_not_matching'))
            :
            this.$t('errors.min_length', {min: 5})
        return
      }

      this.errors[field] = false
    },
    recover (e) {
      e.preventDefault()
      this.$store.commit(SET_IS_ERROR, false)
      this.$store.dispatch('recoverPassword', {password: this.password, token: this.token})
      .then(() => {
        if (!this.$store.getters.isError) {
          this.$store.dispatch('success', this.$t('messages.account_updated'))
          this.$router.push(this.$route.query.redirect || '/signup/login')
        }
      })
    }
  },
  mounted() {
    this.token = this.$route.query.token

    const inviteCodes = parseInviteCodesFromUri(this.$route.params.codes)
    if (inviteCodes!=null && inviteCodes.length>0) {
      this.$store.commit(SET_INVITE_CODES, inviteCodes)
    }

    if (!this.token) {
      this.$router.push({path: '/signup/login', query: this.$route.query})
    }
  },
  components: {
    InputGroup,
    PrimaryButton,
    Modal,
    OutlineButton
  }
}
</script>

<style lang="scss" scoped>
.button-link {
  margin-top: 15px;

  display: inline-block;
}
.button-row {
  display: flex;
  align-items: baseline;
  padding-bottom: 4rem;
  width: 100%;
}
</style>


